import { Component } from '@angular/core';

import type { MatcherComponentRegistryService } from '@cdw-ae/filter-bar-core';
import { ContainsMatcher } from '@cdw-ae/filter-bar-matcher-configs';
import { TextMatcherComponent } from './text-matcher/text.matcher';

@Component({
  selector: 'cdw-contains-matcher',
  template: `
    <mat-form-field [formGroup]="state" appearance="fill" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
      <mat-label>{{ matcherDisplayName }}</mat-label>
      <input data-testid="text-input" formControlName="textControl" matInput cdkFocusInitial />
      <mat-error class="matcher-error" *ngFor="let error of errorMessages">
        {{ error }}
      </mat-error>
    </mat-form-field>
  `,
  styleUrls: ['./text-matcher/text.matcher.scss'],
  standalone: false,
})
export class ContainsMatcherComponent extends TextMatcherComponent {
  constructor() {
    super();
    this.matcherDisplayName = ContainsMatcher.displayName;
    this.matcherName = ContainsMatcher.name;
  }

  /**
   * Register this component with the matcher registry
   */
  public static registerContains(
    registry: MatcherComponentRegistryService
  ): void {
    registry.registerComponent('contains', ContainsMatcherComponent);
  }
}
